
















import Vue from 'vue';
import { CountryObject } from './util/types';
import List from './components/List.vue';
import getCountries from './util/getCountries';
import getCookie from "@/util/getCookie";

export default Vue.extend({
  name: 'App',
  components: {
    List
  },
  data() {
    return {
      allCountriesSearch: [] as string[][],
      allCountries: [] as string[][],
      searching: false
    }
  },
  methods: {
    searchCountry: function(event: Event) {
      const query: string = (event.target as HTMLInputElement).value.toLowerCase();
      this.searching = query? true : false
      const regex = new RegExp(query);
      this.allCountriesSearch = [];
      const result = this.allCountries.filter(x => x[0].toLowerCase().match(regex));
      if (result.length === 0) {
        this.allCountriesSearch.push(["Couldn't find " + query]);
      }
      result.forEach(item => {
        this.allCountriesSearch.push(item);
      })
    },

  },
  mounted() {
    const isUS = getCookie('nf_lang') === "en-us"
    getCountries().then(data => {
      data.forEach((country: CountryObject) => {
        if (!isUS) {
          if (country.countryCode !== "US") {
            this.allCountries.push([country.countryName, country.countryCode]);
          }
        } else {
          this.allCountries.push([country.countryName, country.countryCode]);
        }
      });
    })
  },
});
